export const contrastColor = (hexColor?: string) => {
    if (!hexColor) {
        return "#000000"
    }

    // Remove the hash at the start if it's there
    hexColor = hexColor.replace(/^#/, "");

    // Parse the r, g, b values
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);

    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // If luminance is greater than 0.5, return black, otherwise white
    return luminance > 0.5 ? "#000000" : "#ffffff";
}
